import { Line, LineChart, Tooltip, XAxis, YAxis } from "recharts"
import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu"
import GeneralHeatmapRow from "../../../../components/GeneralHeatmapRow/GeneralHeatmapRow"
import AnalysisSection from "../AnalysisSection/AnalysisSection"
import { ThermalSectionProps } from "./ThermalSection.types"
import { useEffect, useState } from "react"
import { Dict } from "../../../../types/types"
import { GeneralHeatmapRange } from "../../../../components/GeneralHeatmapRow/GeneralheatmapRow.types"
import SkeletonLoadingView from "../../../../components/SkeletonLoadingView/SkeletonLoadingView"

const ThermalSection = (props: ThermalSectionProps) => {
  const {
    heatmapData,
    sectionThermalData,
    width,
    pixelHeight,
    ellipsisMenu,
    isolatedScan
  } = props

  const [sensor1, setSensor1] = useState<number[]>([])
  const [sensor2, setSensor2] = useState<number[]>([])
  const [graphData, setGraphData] = useState<Dict[]>([])
  const [thermalRange, setThermalRange] = useState<GeneralHeatmapRange>({ min: 0, max: 100 })
  const skeletonLoadingHeight = "8rem"

  useEffect(() => {
    if (heatmapData === undefined) { return }
    if (isolatedScan === undefined) { return }
    if (sectionThermalData === undefined) { return }

    const maxSensor1 = Math.max(...sectionThermalData.map((data) => data.sensor_1).flat()) / 100
    const maxSensor2 = Math.max(...sectionThermalData.map((data) => data.sensor_2).flat()) / 100

    const minSensor1 = Math.min(...sectionThermalData.map((data) => data.sensor_1).flat()) / 100
    const minSensor2 = Math.min(...sectionThermalData.map((data) => data.sensor_2).flat()) / 100
    
    setThermalRange({min: Math.min(minSensor1, minSensor2), max: Math.max(maxSensor1, maxSensor2)})

    let startIndex = 0
    let endIndex = heatmapData.seq_nos.length - 1

    const startCalibration = heatmapData.seq_nos.filter( sequenceNumber => sequenceNumber < isolatedScan.calibration_start_p2)
    const endCalibration = heatmapData.seq_nos.filter( sequenceNumber => sequenceNumber > isolatedScan.calibration_end_p1)
    
    if (startCalibration.length > 0 && endCalibration.length > 0) {
      startIndex = heatmapData.seq_nos.indexOf(startCalibration[startCalibration.length - 1])
      endIndex = heatmapData.seq_nos.indexOf(endCalibration[0])
    }

    if (startIndex === -1 || endIndex === -1) {
      startIndex = 0
      endIndex = heatmapData.seq_nos.length - 1
    }

    if (startIndex > endIndex) {
      [startIndex, endIndex] = [endIndex, startIndex]
    }

    const sensor1 = heatmapData.sensor_1.slice(startIndex, endIndex + 1).map((s) => s / 100)
    const sensor2 = heatmapData.sensor_2.slice(startIndex, endIndex + 1).map((s) => s / 100)
    setSensor1(sensor1)
    setSensor2(sensor2)

    setGraphData(sensor1.map((_, i) => {
      return {
        left_sensor: sensor1[i],
        right_sensor: sensor2[i],
        amt: i
      }
    }))
  }, [heatmapData, isolatedScan, sectionThermalData])


  if (heatmapData === undefined || isolatedScan === undefined) {
    return (
      <AnalysisSection title="Thermal">
        <div className="analysis-section">
          <SkeletonLoadingView style={{height: skeletonLoadingHeight}} />
        </div>
      </AnalysisSection>
    )
  }

  return (
    <AnalysisSection title="Thermal" titleChild={
      <EllipsisMenu ellipsisMenu={ellipsisMenu} />
    }>
      <div className="analysis-section">
        <GeneralHeatmapRow
          heatmap={[sensor1]}
          width={width}
          pixelHeight={pixelHeight}
          colourPallate="temperature"
          range={thermalRange}
        />
        <GeneralHeatmapRow
          heatmap={[sensor2]}
          width={width}
          pixelHeight={pixelHeight}
          colourPallate="temperature"
          range={thermalRange}
        />

      </div>
      {/* <div className="analysis-section">
        {analysisHeatmap.map((scanHeatmap, _) => (
          <GeneralHeatmapRow
            heatmap={scanHeatmap}
            width={width}
            pixelHeight={pixelHeight}
            colourPallate="temperature"
            range={thermalRange}
          />
        ))}
      </div> */}

      <div className="analysis-section">
        <LineChart
          width={width}
          height={100}
          data={graphData}
          margin={{
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
          }}
        >
          <XAxis dataKey="name" />
          <YAxis domain={[thermalRange.min, thermalRange.max]} tick={false} axisLine={false} width={0} />
          <Tooltip />
          <Line animationDuration={300} type="monotone" dataKey={`left_sensor`} stroke={"#FF00FF"} dot={false} />
          <Line animationDuration={300} type="monotone" dataKey={`right_sensor`} stroke={"#82ca9d"} dot={false} />
        </LineChart>
      </div>
    </AnalysisSection>
  )
}

export default ThermalSection